import { ArrowRight, Users } from "lucide-react";
import { Link } from "react-router-dom";

import { Button } from "@/components/ui/button";
import { financeScopeHref } from "@/lib/landingLinks";

/**
 * The fork a larger bookkeeping enquiry reaches.
 *
 * Above the turnover our standard bookkeeping pricing covers, the honest thing
 * is not "you don't qualify" - it is a choice. Most businesses at this level
 * need a finance function; some genuinely have simple books and only want the
 * bookkeeping. Revenue is treated as a strong signal here, never a rule, so
 * both doors are open and neither is a dead end.
 */
export const FinanceRouting = ({ search = "", onContinue, onBack }) => (
  <div
    data-testid="bookkeeping-finance-routing"
    className="tt-card tt-fade-in mx-auto max-w-3xl overflow-hidden"
  >
    <div className="border-b border-border bg-[color:var(--tt-surface-2)] px-5 py-6 sm:px-7">
      <span className="flex h-11 w-11 items-center justify-center rounded-xl bg-[color:var(--tt-teal-mist)] text-primary">
        <Users className="h-5 w-5" aria-hidden="true" />
      </span>
      <h2 className="mt-4 text-xl font-bold leading-snug text-foreground sm:text-[26px]">
        Your business may need a broader finance solution
      </h2>
      <p className="mt-3 max-w-[62ch] text-sm leading-relaxed text-muted-foreground">
        Businesses above R20 million in annual revenue often have more complex finance
        requirements. Our Outsourced Financial Management service provides a finance team led
        by a Financial Manager, with support tailored to your accounting, reporting, cash-flow
        and management requirements.
      </p>
    </div>

    <div className="px-5 py-6 sm:px-7">
      <div className="flex flex-col gap-3 sm:flex-row sm:items-center">
        <Button
          asChild
          size="lg"
          data-testid="bookkeeping-finance-routing-scope"
          className="h-12 min-h-[44px] px-5 text-[15px] font-semibold"
        >
          <Link to={financeScopeHref(null, search)}>
            Scope my finance function
            <ArrowRight className="ml-2 h-4 w-4" aria-hidden="true" />
          </Link>
        </Button>
        <Button
          type="button"
          size="lg"
          variant="outline"
          data-testid="bookkeeping-finance-routing-continue"
          onClick={onContinue}
          className="h-12 min-h-[44px] bg-white px-5 text-[15px] font-semibold"
        >
          I only need bookkeeping
        </Button>
      </div>

      <p className="mt-5 text-[13px] leading-relaxed text-muted-foreground">
        Revenue on its own doesn&apos;t decide this. If your books are straightforward and
        bookkeeping is all you want, carry on and we&apos;ll scope a bookkeeping fee for you.{" "}
        <button
          type="button"
          data-testid="bookkeeping-finance-routing-back"
          onClick={onBack}
          className="tt-link font-semibold"
        >
          Change my answer
        </button>
      </p>
    </div>
  </div>
);
